// import logo from './logo.svg';
import "./App.css";

import RoutesApp from "./routes/RoutesApp";

function App() {
  return (
    <div className="App">
      <RoutesApp />
    </div>
  );
}

export default App;
